export const NAME = 'interstitiel';

/**
 * Here goes the actionTypes
 */
export const REQUEST_RETAGGAGE = 'REQUEST_RETAGGAGE';
export const RECEIVE_RETAGGAGE = 'RECEIVE_RETAGGAGE';
export const FAILURE_RETAGGAGE = 'FAILURE_RETAGGAGE';

export const REQUEST_BYPASS_ADBLOCKER = 'REQUEST_BYPASS_ADBLOCKER';
export const RECEIVE_BYPASS_ADBLOCKER = 'RECEIVE_BYPASS_ADBLOCKER';
export const FAILURE_BYPASS_ADBLOCKER = 'FAILURE_BYPASS_ADBLOCKER';



// WEBPACK FOOTER //
// ./src/services/interstitiel/constants.js